export const onFormatLogStatus = (status: string) => {
    switch (status) {
        case 'in_progress':
            return { name: 'In Progress', color: 'border-[#007AFF]', text: 'text-[#007AFF]' }
        case 'completed':
            return { name: 'Completed', color: 'border-[#008000]', text: 'text-[#008000]' }
        case 'manual_review':
            return { name: 'Manual Review', color: 'border-[#553B02]', text: 'text-[#553B02]' }
        case 'failed':
            return { name: 'Failed', color: 'border-[#FF0000]', text: 'text-[#FF0000]' }
        default:
            return { name: status, color: 'border-[#007AFF]', text: 'text-[#007AFF]' }
    }
}